
import { defineComponent } from "vue";
import { ISystemSubjectsModel } from "@/interfaces/modules";
import SystemSubjectsService from "@/api/Academic/SystemSubjectsService";
import SystemAreasService from "@/api/Academic/SystemAreasService.ts"; // nuevo
import store from "@/store";

export default defineComponent({
  name: "SystemSubjectsContent",
  data() {
    return {
      areas: [] as any[], // listado de áreas
      form: {
        dialog: false,
        record: {} as ISystemSubjectsModel,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Code", label: "Código", sortable: true },
          { key: "Name", label: "Nombre", sortable: true },
          { key: "AreaId", label: "Área", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as ISystemSubjectsModel[],
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    filteredItems(): ISystemSubjectsModel[] {
      const search = this.table.filters.search.toLowerCase();
      return this.table.filters.search
        ? this.table.records.filter(
            (item) =>
              item.Name?.toLowerCase().includes(search) ||
              item.Code?.toLowerCase().includes(search) ||
              item.Description?.toLowerCase().includes(search)
          )
        : this.table.records;
    },
    rows(): number {
      return this.table.records.length;
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await SystemSubjectsService.GetSubjects();
      this.areas = await SystemAreasService.GetAreas(); // traer áreas
      this.table.loading = false;
    },
    async edit(item: ISystemSubjectsModel) {
      this.form.record = await SystemSubjectsService.GetSubjectById(item);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = {
        Id: 0,
        Code: "",
        AreaId: 0,
        Name: "",
        Description: "",
        Enable: true,
        CreatedBy: 0,
        CreatedDate: "",
      } as ISystemSubjectsModel;
      this.form.dialog = true;
    },
    async handleSubmit() {
      this.form.dialog = false;
      await SystemSubjectsService.PostSubject(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro guardado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
